import React, { useState } from "react";
import { PiNotePencilLight } from "react-icons/pi";
import { FiTrash } from "react-icons/fi";
import { IoMdCheckmark } from "react-icons/io";

const NotesCard = ({ note, rows, userName, picture, updateNote, deleteNote, isAuthenticated }) => {
    const [editNote, setEditNote] = useState(false);
    const [clientNote, setClientNote] = useState(note.text);

    const handleEdit = () => {
        setEditNote(true)
    }

    const handleDelete = () => {
        deleteNote(note.id);
    }

    const handleSaveNote = () => {
        setEditNote(false);
        updateNote(note.id, clientNote)
    }

    return (
        <div className='px-3 pt-3 pb-1 bg-white rounded-2xl border border-[#D0D5DD] mb-3'>
            <div className={`grid grid-cols-[auto,2fr,auto] ${!isAuthenticated ? 'hidden' : ''}`}>
                <div className="mr-2">
                    <img src={picture} alt="user" className='w-[40px] height-[40px] rounded-full object-cover' />
                </div>

                <div>
                    <div className="text-md font-medium text-black">{userName}</div>
                    <div className="text-base text-[#98A2B3]">{note.last_changed}</div>
                </div>
                {
                    !editNote ? (
                        <div className="flex gap-2 items-center">
                            <PiNotePencilLight onClick={handleEdit} className='text-gray-500 cursor-pointer' size={20} />
                            <FiTrash onClick={handleDelete} className='text-red-500 cursor-pointer' size={20} />
                        </div>
                    ) : (
                        <div onClick={handleSaveNote} className=''>
                            <IoMdCheckmark className='text-green-500 cursor-pointer' size={20} />
                        </div>
                    )
                }
            </div>
            <textarea
                readOnly={!editNote}
                onChange={(e) => setClientNote(e.target.value)}
                className="w-full py-3 mt-4 px-4 rounded-2xl border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                placeholder="Enter your notes please"
                value={clientNote}
                rows={rows}
            />
        </div>
    );
};

export default NotesCard;